const TOPSHOP = "topshop" as const;
const TOPMAN = "topman" as const;

export const BRAND_TO_FLOOR_MAP = {
  [TOPSHOP]: "1000",
  [TOPMAN]: "1001",
} as const;

export const GENDER_TO_BRAND_MAP = {
  women: TOPSHOP,
  men: TOPMAN,
} as const;

export const FLOOR_TO_BRAND_MAP = {
  "1000": TOPSHOP,
  "1001": TOPMAN,
} as const;

export type FloorKey = typeof TOPSHOP | typeof TOPMAN;
export type FloorCodeKey = keyof typeof FLOOR_TO_BRAND_MAP;
export type GenderBrandKey = keyof typeof GENDER_TO_BRAND_MAP;

export const determineFloorFromPath = (pathname: string): FloorKey | null => {
  const pathSegments = pathname.replace(/^\//, "").split("/");

  for (const segment of pathSegments) {
    const lowerSegment = segment.toLowerCase();
    if (lowerSegment in BRAND_TO_FLOOR_MAP) {
      return lowerSegment as FloorKey;
    }
  }

  return null;
};

export const getFloorFromCookie = (
  cookieValue: string | undefined,
): FloorKey | null => {
  if (cookieValue && cookieValue in FLOOR_TO_BRAND_MAP) {
    return FLOOR_TO_BRAND_MAP[cookieValue as keyof typeof FLOOR_TO_BRAND_MAP];
  }

  return null;
};

export const determineFloor = (
  cookieValue: string | undefined,
  pathname: string,
): FloorKey | null => {
  const floorFromPath = determineFloorFromPath(pathname);
  if (floorFromPath) {
    return floorFromPath;
  }

  const floorFromCookie = getFloorFromCookie(cookieValue);
  if (floorFromCookie) {
    return floorFromCookie;
  }

  return null;
};

export const getFloorCode = (floor: FloorKey): string => {
  return BRAND_TO_FLOOR_MAP[floor];
};

export const getBrandFromGender = (gender: string): FloorKey | null => {
  const lowerGender = gender?.toLowerCase();

  if (lowerGender in GENDER_TO_BRAND_MAP) {
    return GENDER_TO_BRAND_MAP[lowerGender as GenderBrandKey];
  }

  return null;
};
